function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#323D43;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M379.9,318.9c-29.7,0-56.3,13.5-73.9,34.8l-114.7-65.1c3.6-10,5.5-20.8,5.5-32.1c0-11.2-2-22-5.5-32.1 l114.7-65.1c17.6,21.2,44.2,34.8,73.9,34.8c52.9,0,96-43.1,96-96.1c0-53-43.1-96-96-96c-53,0-96,43.1-96,96c0,11.2,2,22,5.5,32.1 l-114.7,65.1c-17.6-21.2-44.2-34.8-73.9-34.8c-53,0-96,43.1-96,96c0,52.9,43.1,96,96,96c29.7,0,56.2-13.5,73.9-34.8l114.7,65.1 c-3.6,10-5.5,20.8-5.5,32.1c0,52.9,43.1,96,96,96c52.9,0,96-43.1,96-96C476,362,432.9,318.9,379.9,318.9z M379.9,35.6 c34.4,0,62.4,28,62.4,62.4c0,34.4-28,62.5-62.4,62.5c-34.4,0-62.4-28-62.4-62.5C317.5,63.6,345.5,35.6,379.9,35.6z M100.9,318.9 c-34.4,0-62.4-28-62.4-62.4c0-34.4,28-62.4,62.4-62.4c34.4,0,62.4,28,62.4,62.4C163.3,290.9,135.3,318.9,100.9,318.9z M379.9,477.4 c-34.4,0-62.4-28-62.4-62.4c0-34.4,28-62.4,62.4-62.4c34.4,0,62.4,28,62.4,62.4C442.4,449.4,414.4,477.4,379.9,477.4z"
});

var SvgDeli = function SvgDeli(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeli, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/deli.dcd18ff8.svg";
export { ForwardRef as ReactComponent };